<template>
  <div data-test-id="form-simplified-enrollment-success">
    <h2 :class="brandClasses.heading">
      {{
        hasIncompleteSubscription
          ? $t.simplifiedEnrollment.successHeadingIncomplete
          : $t.simplifiedEnrollment.successHeadingComplete
      }}
    </h2>
    <div class="mt-6 space-y-2">
      <vf-button v-if="hasIncompleteSubscription" class="w-full" @click="emit('continue')">
        {{ $t.finishProfile }}
      </vf-button>
      <vf-button
        class="w-full"
        :variant="hasIncompleteSubscription ? 'secondary' : 'primary'"
        @click="emit('cancel')"
      >
        {{ $t.close }}
      </vf-button>
    </div>
  </div>
</template>

<script lang="ts" setup>
const emit = defineEmits<{
  cancel: []
  continue: []
}>()

const { $feature } = useNuxtApp()
const { brandClasses } = useAppConfig().components.dialog.simplifiedEnrollment
const user = useUserStore()
const { smsSubscription } = useSubscriptions()

const hasIncompleteSubscription = computed(() => $feature.tempEnablePostAuthOnboarding
  ? user.isPartiallyEnrolled
  : !(user.hasNewsletterSubscription && smsSubscription.value?.optin)
    || !!user.isPartiallyEnrolled || !user.interests.length
)
</script>
